module.exports = __webpack_public_path__ + "img/BJT2.3c4aa143.svg";